import { calculateDaysBetweenDates } from 'base/new-utils';

function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export const mapSnakeToCamel = (object, mappings) => {
  const newObj = {};
  Object.entries(object).forEach(([key, val]) => {
    const camelKey = mappings[key];
    if (camelKey) newObj[camelKey] = val;
  });

  return newObj;
};

export const mapCamelToSnake = (object, mappings) => {
  const newObj = {};
  Object.entries(object).forEach(([key, val]) => {
    const snakeKey = getKeyByValue(mappings, key);
    if (snakeKey) newObj[snakeKey] = val;
  });

  return newObj;
};

const isDateInRange = (date, start, end) => {
  // positive number means date is after start or end
  const numDaysBetweenStartAndDate = calculateDaysBetweenDates(start, date);
  const numDaysBetweenEndAndDate = calculateDaysBetweenDates(end, date);

  // so to be "in range", it should be a positive number for the start date and a negative number for the end date
  return numDaysBetweenStartAndDate >= 0 && numDaysBetweenEndAndDate <= 0;
};

export const updateTasksAfterTimeout = (dataArray, startDate, endDate) => {
  if (!dataArray) return [];
  if (!startDate || !endDate) return dataArray;

  return dataArray.map((obj) => {
    const dateString = obj?.date;
    if (isDateInRange(dateString, startDate, endDate)) {
      return {
        ...obj,
        email: 0,
        phone: 0,
        other: 0,
        total: 0,
        completed: 0,
      };
    }
    return obj;
  });
};

export const getPromotionDetails = (enrichment) => {
  const { employment_events = [] } = enrichment || {};
  let mostRecentEvent = null;
  employment_events.forEach((event) => {
    const eventType = event.type.toLowerCase();
    if (
      ['promotion', 'new job', 'retired'].includes(eventType) &&
      (!mostRecentEvent || event.recorded_at > mostRecentEvent.recorded_at)
    ) {
      mostRecentEvent = event;
    }
  });

  return mostRecentEvent;
};

export const titleCaseString = (string = '') => {
  if (!string.length) return string;
  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const getEmptySectionName = (subtitle) => {
  switch (subtitle) {
    case 'Recent Gift':
      return 'recent gift';
    case 'Promotion':
      return 'promotion';
    case 'Last Gift':
      return 'gift anniversary';
    case 'Contact Reports':
      return 'contact reports';
    default:
      return '';
  }
};
